<template>
  <div class="position-assignments-table">
    <div class="subtitle-2 font-weight-medium mb-2">Positionszuweisungen:</div>
    <v-card outlined>
      <v-simple-table dense class="position-table">
        <template v-slot:default>
          <thead class="v-row-group__header">
            <tr>
              <th class="text-left">Position</th>
              <th class="text-left">Status</th>
              <th class="text-left">Besetzung</th>
              <th class="text-left">Zugewiesene Personen</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="position in positionDetails"
              :key="position.position"
              :class="getRowClass(position)"
            >
              <!-- Position Name -->
              <td class="font-weight-medium">
                {{ position.position }}
                <v-chip
                  v-if="position.isOptional"
                  x-small
                  outlined
                  color="blue"
                  class="ml-1"
                >
                  Optional
                </v-chip>
              </td>

              <!-- Status -->
              <td>
                <v-icon :color="getStatusIconColor(position.status)" small>
                  {{ getPositionStatusIcon(position.status) }}
                </v-icon>
              </td>

              <!-- Occupancy -->
              <td>
                <span class="font-weight-medium">
                  {{ position.assigned.length }}/{{
                    position.positionData.requiredCounter || 1
                  }}
                </span>
                <span v-if="position.missing > 0" class="red--text ml-1">
                  (-{{ position.missing }})
                </span>
              </td>

              <!-- Assigned Personnel -->
              <td>
                <div
                  v-if="position.assigned.length > 0"
                  class="d-flex flex-wrap"
                >
                  <v-chip
                    v-for="person in position.assigned"
                    :key="person"
                    x-small
                    outlined
                    class="mr-1 mb-1"
                  >
                    {{ person }}
                  </v-chip>
                </div>
                <span v-else class="grey--text">Nicht besetzt</span>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "PositionAssignmentsTable",
  props: {
    positionDetails: {
      type: Array,
      required: true,
    },
  },
  methods: {
    getRowClass(position) {
      return {
        "success-row": position.status === "fulfilled",
        "error-row":
          position.status === "not_fulfilled" && !position.isOptional,
        "warning-row": position.missing > 0 && position.assigned.length > 0,
        "optional-row": position.isOptional,
      };
    },
    getStatusIconColor(status) {
      switch (status) {
        case "fulfilled":
          return "green darken-4";
        case "partially_fulfilled":
          return "orange darken-4";
        case "not_fulfilled":
          return "red darken-4";
        default:
          return "grey darken-4";
      }
    },
    getPositionStatusIcon(status) {
      switch (status) {
        case "fulfilled":
          return "mdi-check-circle";
        case "not_fulfilled":
          return "mdi-close-circle";
        default:
          return "mdi-help-circle";
      }
    },
  },
};
</script>

<style scoped>
.position-table {
  border-radius: 4px;
  overflow: hidden;
}

.position-table .success-row {
  background-color: #e8f5e8;
}

.position-table .error-row {
  background-color: #ffebee;
}

.position-table .warning-row {
  background-color: #fff3e0;
}

.position-table .optional-row {
  background-color: #f3f8ff;
}
</style>
